<template>
  <div class="row">
    <div class="col-lg-6 col-sm-12">
      <div class="card">
        <div class="card-header">
          <div class="d-md-flex align-items-center">
            <div>
              <h4 class="card-title">
                <i class="far fa-clone" /> Clusters
              </h4>
              <h5 class="card-subtitle">
                Cconfigure a new cluster here.
              </h5>
            </div>
            <div class="ml-auto">
              <div class="d-flex flex-row">
                <button v-if="isAuditor()" class="btn waves-effect waves-light btn-success" @click="addCluster()">
                  Add Cluster
                </button>
                &nbsp;
                <div class="btn-group">
                  <button aria-expanded="false" aria-haspopup="true" class="btn btn-light dropdown-toggle" data-toggle="dropdown" type="button">
                    Sort By
                  </button>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" href="javascript:void(0)">Farm Name</a>
                    <a class="dropdown-item" href="javascript:void(0)">Area</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="table-responsive">
            <table class="table no-wrap v-middle">
              <thead>
                <tr class="border-0">
                  <th class="border-0">
                    Cluster Name
                  </th>
                  <th class="border-0">
                    Geo Location
                  </th>
                  <th class="border-0">
                    Descriptions
                  </th>
                  <th class="border-0">
                    Farms
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(cluster, index) in clusters" :key="index" style="cursor: pointer;" @click="viewCluster(cluster.cluster_id)">
                  <td>{{ cluster.name }}</td>
                  <td>
                    <button class="btn waves-effect waves-light btn-success" @click="viewClusterOnMap(cluster.geo)">
                      View in Map
                    </button>
                  </td>
                  <td>{{ cluster.description }}</td>
                  <td>{{ (cluster.farms).join(', ') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div id="map" class="col-lg-6 map" style="min-height: 800px;">
      <!--<div id="map" class="map"></div>-->
      <!--<MglMap :accessToken="accessToken" :mapStyle="mapStyle">-->
      <!--<MglNavigationControl position="top-right"/>-->
      <!--<MglGeolocateControl position="top-right"/>-->
      <!--<MglScaleControl/>-->
      <!--</MglMap>-->
    </div>
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl'
import {
  MglMap,
  MglAttributionControl,
  MglNavigationControl,
  MglGeolocateControl,
  MglFullscreenControl,
  MglScaleControl
} from 'vue-mapbox'
import { mapGetters } from 'vuex'

export default {
  name: 'Clusters',
  components: { MglMap, MglAttributionControl, MglNavigationControl, MglGeolocateControl, MglFullscreenControl, MglScaleControl },
  computed: {
    ...mapGetters(['currentUser'])
  },
  data () {
    return {
      map: null,
      tileLayer: null,
      layers: [],
      clusterMap: [],
      accessToken: this.$MAP_BOX,
      mapStyle: 'mapbox://styles/vkandy/cjsay43ka0grz1fnz1b3oe8gh',
      clusters: [],
      pageCount: 1,
      total: 0
    }
  },
  mounted () {
    this.getClusterList(1)
  },
  methods: {
    initMap () {
      this.map = L.map('map').setView([38.63, -90.23], 12)
      this.tileLayer = L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          maxZoom: 18,
          attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }
      )
      this.tileLayer.addTo(this.map)
      var jsonLayer = L.geoJson(this.clusterMap, { color: 'green' })
      jsonLayer.addTo(this.map)
      this.map.fitBounds(jsonLayer.getBounds())
    },
    initLayers () {
    },
    viewCluster (cluster_id) {

    },
    addCluster () {
      this.$router.push({ name: 'newcluster' })
    },
    async getClusterList (page) {
      // let reply = await this.$api.get(`/clusters`, {
      //     params: {
      //         page: page,
      //         perPage: 10
      //     }
      // });
      //
      // this.total      = reply.data.totalSize;
      // this.clusters   = reply.data.slice;
      // this.clusterMap = this.clusters.map((cluster) => {
      //     return cluster.geo
      // });
      // this.initMap();
      // this.setPageCount();
    },
    pageHandler (pageNum) {
      this.getFieldList(pageNum)
    },
    setPageCount () {
      this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10)
    },
    viewClusterOnMap (coords) {
      var jsonLayer = L.geoJson(coords)
      this.map.fitBounds(jsonLayer.getBounds())
    },
    isAuditor () {
      return true
    }
  }
}
</script>

<style scoped>
</style>
